import { Body } from '../../molecules/invoice/SharedStyle'

import { Customer as customerDelivery } from '../../molecules/invoice/delivery/types'
import { Customer as customerPurchase } from '../../molecules/invoice/purchase/types'
import { OrderItem } from '../../molecules/invoice/purchase/types'
import { ProductBucket as ProductBucketsInterface } from '../../molecules/invoice/delivery/types'
import SectionDetails from './SectionDetails'

import HeaderCommunication from '../../molecules/invoice/HeaderCommunication'
import InvoiceBottom from '../../molecules/invoice/InvoiceBottom'
import { TWO_DAYS_STORES } from '../../../common/constants'
import OrderHeader from '../../molecules/invoice/OrderHeader'
interface Props {
  productBuckets: (OrderItem | ProductBucketsInterface)[]
  customer: customerDelivery | customerPurchase
  orderIds: number[]
  creationDatetime: Date
  payment: string
  isDelivery: boolean
  planId: string
  deliveryFee: number
  installments: number
}

const InvoiceDetails = ({
  isDelivery,
  orderIds,
  creationDatetime,
  payment,
  planId,
  customer,
  productBuckets,
  deliveryFee,
  installments,
}: Props) => {
  const outsourcedProducts: (OrderItem | ProductBucketsInterface)[] = []
  const clubbiProducts: (OrderItem | ProductBucketsInterface)[] = []
  productBuckets.forEach((product) => {
    if (TWO_DAYS_STORES.includes(product.storeId)) {
      outsourcedProducts.push(product)
    } else {
      clubbiProducts.push(product)
    }
  })

  return (
    <Body>
      <OrderHeader
        isDelivery={isDelivery}
        customer={customer}
        orderIds={orderIds}
        creationDatetime={creationDatetime}
        planId={planId}
        payment={payment}
      />
      <HeaderCommunication isDelivery={isDelivery} />

      <SectionDetails
        productBuckets={clubbiProducts}
        isDelivery={isDelivery}
        isOutsourced={false}
      />
      {outsourcedProducts.length > 0 && (
        <SectionDetails productBuckets={outsourcedProducts} isDelivery={isDelivery} isOutsourced />
      )}

      <InvoiceBottom
        deliveryFee={deliveryFee}
        isDelivery={isDelivery}
        customer={customer}
        productBuckets={productBuckets as OrderItem[]}
        installments={installments}
      />
    </Body>
  )
}

export default InvoiceDetails
